import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import CaseManagerSelector from './CaseManagerSelector';
import BookingActions from './BookingActions';
import CustomerDetails from './CustomerDetails';
import VehicleDetails from './VehicleDetails';

import { HeaderBlockContainer, Header, StyledCol } from './styled';

class BookingHeader extends PureComponent {
  render() {
    const { addNoteAction, authUser, booking, cancelBooking, chargePayment, chargeInstalment, patchBooking, segment } =
      this.props;

    return (
      <Header>
        <StyledCol span={6}>
          <CustomerDetails authUser={authUser} booking={booking} customer={booking.customer} notes={booking.notes} />
        </StyledCol>
        <StyledCol span={8}>
          <VehicleDetails
            bookingId={booking.bookingId}
            segment={segment}
            vehicle={booking.vehicle}
            vehicleIdentificationMethod={booking.vehicleIdentificationMethod}
            vehicleWeight={booking.vehicle?.weight || 0}
          />
        </StyledCol>
        <StyledCol span={10}>
          <HeaderBlockContainer className="no-border">
            <BookingActions
              addNoteAction={addNoteAction}
              booking={booking}
              cancelBooking={cancelBooking}
              chargePayment={chargePayment}
              chargeInstalment={chargeInstalment}
              patchBooking={patchBooking}
            />
            <div>
              <CaseManagerSelector
                bookingStatus={booking.masterStatusId}
                caseManagerId={booking.caseManagerId}
                onCaseManagerChange={patchBooking}
              />
            </div>
          </HeaderBlockContainer>
        </StyledCol>
      </Header>
    );
  }
}

export default withRouter(BookingHeader);
